// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__p2gjO","col":"styles_col__1GR5n"};